// Agents support assignables. La support-api n'expose pas d'endpoint « liste des agents » :
// renseigner ici le `sub` Keycloak de chaque agent (realm vivapilot) et son nom affiché.
// TODO: remplacer par une source dynamique (rôle Keycloak « agent support ») quand elle existera.
export const SUPPORT_AGENTS = [
  // { id: "<keycloak-sub>", name: "Sarah Amrani (L2)" },
];

export const supportAgentName = (id) => SUPPORT_AGENTS.find((a) => a.id === id)?.name;
